import React from 'react';
import { Ads } from '../components/shared/Ads';
import { Col } from 'react-bootstrap';
import { InternetBanking } from '../components/user/InternetBanking';

/**
 * Create Internet Banking user page
 * @returns {JSX}
 */
const InternetBankingPage = () => {
  return (
    <>
      <Col className="p-0" xs={12} md={6} xl={7}>
        <InternetBanking />
      </Col>
      <Col className="p-0 d-none d-md-block" md={6} xl={5}>
        <Ads />
      </Col>
    </>
  );
};

export default InternetBankingPage;